var _rect, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _ellipse, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3685 137.372C27.1228 142.648 30.267 148.409 39.1231 150.5C47.9793 152.591 53.7675 148.939 55.0131 143.664C56.2587 138.388 52.4901 133.488 43.634 131.397C34.7779 129.305 29.6141 132.097 28.3685 137.372Z",
    fill: "#1C1B1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5353 161.523C40.9719 163.933 44.1607 168.77 45.423 168.836",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5886 170.358C64.263 167.869 48.1751 164.934 42.4287 173.11",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M449.697 319.239C459.006 342.402 467.465 347.996 479.485 352.813C507.411 364.005 509.273 332.296 499.964 319.239C492.517 308.794 469.556 270.123 459.006 252.092C439.644 184.946 390.121 173.133 367.78 175.62H244.905C228.521 175.62 216.979 168.159 213.255 164.429L161.126 102.877C127.614 73.0359 81.0708 100.39 69.9003 117.799C67.0258 122.278 63.6945 124.638 60.5916 125.26C32.2936 126.752 37.6303 155.724 43.8358 170.024C45.6973 181.215 60.5487 192.522 68.3312 191.111C87.4874 187.636 114.875 197.955 114.875 216.352L115.735 240.901C115.735 278.362 143.129 308.048 161.126 319.239V399.442C129.849 399.442 134.441 419.338 140.647 429.285H205.808V405.038C205.808 355.797 210.773 316.131 213.255 302.453C254.958 317.374 327.442 301.209 358.471 291.261C364.429 322.597 398.189 345.352 414.324 352.813V399.442C386.025 400.935 388.88 419.96 393.845 429.285H449.697V319.239ZM449.697 319.239C445.617 304.846 442.816 291.261 440.388 271.774",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.915 84.4577C116.563 83.78 111.963 86.1295 110.964 87.814C105.968 97.1929 112.801 114.969 117.608 123.08C133.675 150.32 151.03 151.85 157.699 149.21C152.212 139.079 154.643 116.896 156.544 107.071C160.528 90.026 141.785 84.8934 131.915 84.4577Z",
    fill: "#1C1B1F",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M350.767 428.684L303.647 381.564",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 257.706,
    cy: 309.706,
    r: 83.2057,
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M311.072 311.617C322.55 293.776 329.713 287.077 325.717 281.536L189.165 281.536C195.498 291.341 197.088 294.322 198.268 301.326C203.457 332.115 246.848 335.886 257.658 335.334C281.526 335.996 309.234 320.721 311.072 311.617Z",
    fill: "url(#paint0_linear_227_11777)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.9079,
    cy: 8.28203,
    rx: 11.9079,
    ry: 8.28203,
    transform: "matrix(-0.99873 0.0503843 -0.0606808 -0.998157 254.328 317.86)",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M331.39 281.174L312.259 306.077C298.802 324.679 280.635 338.72 260.234 338.72C239.834 338.72 214.892 320.325 203.018 306.077L184.024 281.174",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8003 122.309C86.6837 121.163 70.8563 120.249 64.4792 125.757C70.7247 126.27 84.5816 129.52 90.0452 138.407",
    stroke: "#1C1B1F",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_227_11777",
    x1: 256.847,
    y1: 335.365,
    x2: 256.847,
    y2: 281.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#282828",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/일반외과_유선종양.d7f382d0b7bb117156b39e202aa3cf54.svg";
export { ForwardRef as ReactComponent };